import { apiDelete, apiGet, apiPost, apiPut, queryString, type ApiResult } from "./client";
import type { Center, ClosureReason, ClosureResult, TravelEntry, TravelTimes } from "./types";

export interface CenterFields {
  name: string;
  address: string;
  note: string;
}

export interface NewClosure {
  dateFrom: string;
  dateTo: string;
  reason: ClosureReason;
  note: string;
  alsoForCenterIds: string[];
}

export async function fetchCenters(includeArchived: boolean): Promise<ApiResult<Center[]>> {
  return apiGet<Center[]>("/centers" + queryString({ includeArchived }));
}

export async function fetchCenter(id: string): Promise<ApiResult<Center>> {
  return apiGet<Center>(`/centers/${id}`);
}

export async function createCenter(fields: CenterFields): Promise<ApiResult<Center>> {
  return apiPost<Center>("/centers", fields);
}

export async function updateCenter(id: string, fields: CenterFields, version: number): Promise<ApiResult<Center>> {
  return apiPut<Center>(`/centers/${id}`, { ...fields, version });
}

export async function setCenterArchived(id: string, archived: boolean, version: number): Promise<ApiResult<Center>> {
  const action: string = archived ? "archive" : "unarchive";
  return apiPost<Center>(`/centers/${id}/${action}`, { version });
}

export async function deleteCenter(id: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/centers/${id}`);
}

export async function addClosure(centerId: string, closure: NewClosure): Promise<ApiResult<ClosureResult>> {
  return apiPost<ClosureResult>(`/centers/${centerId}/closures`, closure);
}

export async function removeClosure(centerId: string, closureId: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/centers/${centerId}/closures/${closureId}`);
}

export async function fetchTravelTimes(): Promise<ApiResult<TravelTimes>> {
  return apiGet<TravelTimes>("/travel-times");
}

export async function saveTravelTimes(entries: TravelEntry[], version: number): Promise<ApiResult<TravelTimes>> {
  return apiPut<TravelTimes>("/travel-times", { entries, version });
}
